import { configureStore } from "@reduxjs/toolkit";
import previewReducer from "./features/featureSlice";

const store = configureStore({
  reducer: {
    preview: previewReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
